import { ChangeEvent, FC, ReactNode } from "react";
import { Flex, Radio, Text } from "@chakra-ui/react";
import { PlanType } from "sdk/types";

export interface RadioOption {
  description?: string | ReactNode;
  label?: string;
  plan?: PlanType;
  value: string;
}

interface Props extends RadioOption {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const RadioInput: FC<Props> = ({ description, label, onChange, value }) => {
  return (
    <Flex align="flex-start">
      <Radio mr={2} mt={1} onChange={onChange} value={value} variant="th-outline" />
      <Flex align="flex-start">
        <Text fontWeight="bold" minW={50}>
          {label}
        </Text>
        {description && <Text>{description}</Text>}
      </Flex>
    </Flex>
  );
};
